import { useEffect } from "react";
import { Button, Card, FloatingLabel, Form } from "react-bootstrap"
import { executeLaravelAPI, userToken } from "../../Utils";
import Cookies from 'js-cookie';
import AsyncSelect from 'react-select/async';

function ExcelUploadForm({ handleFile, handleSubmit, locationData, setLocationData, selectedLocation, handleLocationChange, formError, developerData,
    selectedDeveloper,
    setSelectedDeveloper }) {


    const fetchLocations = async () => {
        try {
            const params = {
                page: 1,
                per_page: 1000,
                show_all: 1,
                city: Cookies.get("selectedCityCookie") || "pune"
            }; // add params if required

            const result = await executeLaravelAPI('locations', params, 'GET', userToken);
            // assuming result.data contains actual array
            setLocationData(result?.data?.data || []);

        } catch (error) {
            console.error("Error fetching locations:", error);
        }
    };

    const handleDeveloper = (option) => {
        setSelectedDeveloper(option);
    };

    useEffect(() => {
        fetchLocations();

    }, [])

    const loadOptions = async (inputValue) => {
        if (inputValue.length > 2) {
            try {
                const paramsDev = {
                    name: inputValue,
                    searchtype: "developers"
                };

                const response = await executeLaravelAPI(
                    "developersinsearch",
                    paramsDev,
                    "GET",
                    userToken
                );

                return response.data.data.map(dev => ({
                    label: dev.name,
                    value: dev.id
                }));

            } catch (error) {
                console.error("Error fetching developers:", error);
                return [];
            }
        }
        return [];
    };

    return (
        <div>
            <Form onSubmit={handleSubmit} className='developerForm' encType="multipart/form-data" >
                <div className="row">
                    <div className="col-md-12 mb-2">
                        <Card border="" style={{ width: '100%' }}>
                            <Card.Header>Upload File</Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Location">
                                                    <select name="location" id="location" className={`form-control ${formError?.location ? "is-invalid" : ""}`}
                                                        value={selectedLocation} onChange={handleLocationChange}  >
                                                        <option value="">--Select Location--</option>
                                                        {

                                                            locationData?.map((locationObj) => (
                                                                <option key={locationObj?.slug} value={locationObj.slug}>
                                                                    {locationObj.name}
                                                                </option>
                                                            ))

                                                        };
                                                    </select>
                                                    {formError.location && (
                                                        <div className="invalid-feedback">{formError.location}</div>

                                                    )}

                                                </FloatingLabel>

                                            </div>
                                        </Form.Group>
                                    </div>

                                    <div className='col-md-6 mb-2'>

                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={loadOptions}
                                            defaultOptions={developerData}
                                            value={selectedDeveloper}
                                            onChange={handleDeveloper}
                                            placeholder="Search Developers..."
                                            className="customSelectStyle"
                                        />


                                    </div>

                                    <div className="col-md-6 mb-2">
                                        <Form.Group className="row">
                                            <div className="col-sm-12">
                                                <FloatingLabel controlId="floatingInput" label="Upload Excel File">
                                                    <Form.Control type="file" className="form-control" name="upload_file" onChange={handleFile} isInvalid={!!formError.file}
                                                    />

                                                    <Form.Control.Feedback type="invalid">
                                                        {formError.file}
                                                    </Form.Control.Feedback>

                                                </FloatingLabel>
                                            </div>
                                        </Form.Group>
                                    </div>

                                </div>
                            </Card.Body>
                            <Card.Footer className="text-end text-muted">
                                <Button variant="success" type="submit" className="theme-btn">Submit</Button>

                            </Card.Footer>
                        </Card>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default ExcelUploadForm